import { AxiosError, AxiosResponse } from 'axios';

import TokenService, { refreshToken } from '../services/token';

import { AUTH_SERVICE_URL } from '../constants/externalRoutes';
import { conditionalRedirect } from '../utils/navigation';

import api from '../utils/api';

interface AuthServiceInterface {
  authorize: () => Promise<refreshToken>;
}

const authorize = () => {
  return api(`${AUTH_SERVICE_URL}/refreshToken`, {
    method: 'POST',
    withCredentials: true,
  })
    .then((response: AxiosResponse) => {
      return response.data as refreshToken;
    })
    .catch((error: AxiosError) => {
      TokenService.removeRefreshToken();

      const url = `${AUTH_SERVICE_URL}/?redirectUrl=${encodeURIComponent(window.location.href)}`;
      conditionalRedirect(url, 'replace');

      throw error;
    });
};

const AuthService: AuthServiceInterface = {
  authorize,
};

export default AuthService;
